import {MNullable} from '../Toolkit/Utils';
import * as Yup from 'yup';

export class SafeDigFile {
    public static readonly MaxFileSizeMb = 30;

    public safeDigFilesId: number = 0;
    public safeDigsId: number = 0;
    public fileType: number = 0;
    public fileArea: number = 0;
    public startDate: MNullable<Date> = null;
    public expiryDate: Date = new Date();
    public lineSearchPositive: boolean = false;
    public fileStatus: number = 0;
    public fileLocation: string = '';
    public fileInfo: string = '';
    public fileName: string = '';
    public includeInPrint: boolean = false;
    public createdOn: Date = new Date();
    public createdBy: string = '';
    public modifiedOn: Date = new Date();

}

export class CreateSafeDigFileValidator {
    public static readonly filePath = Yup.string().label('File Path').max(255).required();
}

export class UpdateSafeDigFileValidator {
    public static readonly filePath = Yup.string().label('File Path').max(255).required();
}

export class SafeDigFileReply {
    public data: MNullable<SafeDigFile> = null;
}

export class SafeDigFileListReply {
    public data: SafeDigFile[] = [];
}

export class CreateSafeDigFileReply {
    public data: MNullable<SafeDigFile> = null;
    public statusCode: number = 0;
    public message: string = '';
}

export class UpdateSafeDigFileReply {
    public value: number = 0;
    public statusCode: number = 0;
    public message: string = '';
}